export function showComparePlansTable() {
    $('.view-all-table .button').on('click', function () {
        const tableWrap = $(this).closest('.compare-plans-table');
        const table = tableWrap.find('.table');
        const fullHeightTable = table[0].scrollHeight;
        table.css('max-height', fullHeightTable + 'px');
        tableWrap.addClass('opened');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/showComparePlansTable.js